export default __webpack_public_path__ + "static/media/RECYCLING.abd45726.jpg";